export default __webpack_public_path__ + "static/media/exchange.4758c9ca.svg";